import { initializeApp } from 'firebase/app';

const preprodConfig = {
  apiKey: 'AIzaSyBPUOmobkJvSxcG0zLiwoJCf0d2T5-NXm4',
  authDomain: 'nrk-pin-sport-preprod.firebaseapp.com',
  projectId: 'nrk-pin-sport-preprod',
  storageBucket: 'nrk-pin-sport-preprod.firebasestorage.app',
  messagingSenderId: '572420861269',
  appId: '1:572420861269:web:311375b9972e95bdb193dc',
};
const prodConfig = {
  apiKey: 'AIzaSyAinLLmoGR4bFJgnzbv3_f3wgasaaVUzso',
  authDomain: 'nrk-pin-sport-prod.firebaseapp.com',
  projectId: 'nrk-pin-sport-prod',
  storageBucket: 'nrk-pin-sport-prod.firebasestorage.app',
  messagingSenderId: '923054432305',
  appId: '1:923054432305:web:f7b6963eae4b925772f510',
};
const firebaseConfig =
  import.meta.env.VITE_APP_ENV === 'prod' ? prodConfig : preprodConfig;

export const app = initializeApp(firebaseConfig);
